import React from 'react';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { comparison, differentiators, solution } from '../data/content';
export function SolutionSection() {
  return <section className="border-y border-night-line bg-night" data-id="element-158" data-mp="3o9aiz7yy33y3">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-6 lg:py-24" data-id="element-159" data-mp="3oavdwyp68owh">
        <div className="mx-auto max-w-2xl text-center" data-id="element-160" data-mp="3j960jceh7z58">
          <h2 className="font-display text-[1.75rem] font-semibold leading-tight tracking-tight text-parchment sm:text-4xl" data-id="element-161" data-mp="14kxj4xusvkn">
            {solution.title}
          </h2>
          <p className="mt-4 font-sans text-base leading-relaxed text-parchment/70 sm:text-lg" data-id="element-162" data-mp="3t85085h9kkg3">
            {solution.description}
          </p>
        </div>

        <ul className="mt-10 grid gap-4 md:grid-cols-3" data-id="element-163" data-mp="5v1aknxrif6h">
          {differentiators.map(item => <li key={item.title} className="rounded-2xl border border-night-line bg-night-panel p-6" data-id="element-164" data-mp="krse99egyd1w">
              <h3 className="font-display text-xl font-semibold leading-snug text-gold-soft" data-id="element-165" data-mp="fvblu308lcj0">
                {item.title}
              </h3>
              <p className="mt-3 font-sans text-[0.95rem] leading-relaxed text-parchment/75" data-id="element-166" data-mp="3b970tbwe8znn">
                {item.description}
              </p>
            </li>)}
        </ul>

        <div className="mx-auto mt-14 max-w-3xl" data-id="element-167" data-mp="3ka58c461jpaz">
          <h3 className="text-center font-display text-2xl font-semibold leading-tight text-parchment sm:text-3xl" data-id="element-168" data-mp="3kbygxp07sjlm">
            ¿Por qué es diferente?
          </h3>

          <div className="mt-6 overflow-hidden rounded-2xl border border-night-line" data-id="element-169" data-mp="3u7rpyyeq5uyn">
            <div className="grid grid-cols-2 bg-night-panel" data-id="element-170" data-mp="2u5dy2c3nbu8">
              <p className="px-4 py-3 font-sans text-xs font-semibold uppercase tracking-[0.12em] text-parchment/50 sm:px-6" data-id="element-171" data-mp="2w03jtybfs4n">
                Versículos sueltos
              </p>
              <p className="border-l border-night-line px-4 py-3 font-sans text-xs font-semibold uppercase tracking-[0.12em] text-gold-soft sm:px-6" data-id="element-172" data-mp="bw4z96u5d22z">
                Botiquín Espiritual
              </p>
            </div>
            <ul className="divide-y divide-night-line" data-id="element-173" data-mp="2cuqgh6sgaa2c">
              {comparison.map(row => <li key={row.kit} className="grid grid-cols-2" data-id="element-174" data-mp="27vnb1l8k61tu">
                  <p className="flex gap-2 px-4 py-4 font-sans text-sm leading-relaxed text-parchment/55 sm:px-6 sm:text-[0.95rem]" data-id="element-175" data-mp="2mnebpx3s85yy">
                    <MinusIcon className="mt-0.5 h-4 w-4 flex-none text-parchment/35" aria-hidden="true" data-id="element-176" data-mp="2httalw6w6vvj" />
                    {row.loose}
                  </p>
                  <p className="flex gap-2 border-l border-night-line bg-gold/5 px-4 py-4 font-sans text-sm font-medium leading-relaxed text-parchment sm:px-6 sm:text-[0.95rem]" data-id="element-177" data-mp="2rknzl8biw9ko">
                    <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-gold-soft" aria-hidden="true" data-id="element-178" data-mp="30lvrn8ng4e6b" />
                    {row.kit}
                  </p>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}